var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",class:['typer','reveal',_vm.mode,_vm.isFadeOut ? 'fadeout': '']})
}
var staticRenderFns = []

export { render, staticRenderFns }